import { cx } from 'components/crm/ui/uiUtils';

// A row of shortcuts (a day, a time, a length): the one chosen is orange, a
// click picks one. `options`: [[value, label]].
const ChoiceChips = ({ options, value, onPick }) => (
  <div className="flex flex-wrap gap-1.5">
    {options.map(([option, label]) => (
      <button
        key={option}
        type="button"
        aria-pressed={value === option}
        onClick={() => onPick(option)}
        className={cx(
          'rounded-full border px-2.5 py-1 text-xs font-medium transition-colors',
          value === option
            ? 'border-primary bg-primary-tint text-primary-dark'
            : 'border-lineStrong text-body hover:bg-gray-50',
        )}
      >
        {label}
      </button>
    ))}
  </div>
);

export default ChoiceChips;
